import { StyleValue } from '@/shared/app/model/StyleValue';
import { v4 as uuid } from 'uuid';
import Slots from '../app/model/templating/Slots';
import Dataset from '../data/model/Dataset';

const imageExtensions = ['png', 'jpg', 'jpeg', 'webp', 'gif', 'svg'];
const videoExtensions = ['mp4', 'webm'];

export const tmpCommAddToSlots = (
  slots: Slots,
  config: Dataset,
  url: string,
  options?: {
    duration?: number;
    loop?: boolean;
    videoComponent?: string;
    backgroundSize?: StyleValue['backgroundSize'];
    backgroundPosition?: string;
  },
) => {
  const randomSlotId = uuid().substring(0, 8);
  const slotName = `comm${randomSlotId}`;
  const extension = url.split('.').pop();
  if (!extension) return;

  // Si c'est une vidéo
  if (videoExtensions.includes(extension)) {
    slots[slotName] = {
      component: options?.videoComponent || 'Video',
      config: {
        videoSrc: url,
        loop: options?.loop || false,
      },
    };
    config[`${slotName}Trigger`] = 'done';
  } else if (imageExtensions.includes(extension)) {
    slots[slotName] = {
      component: 'Box',
      config: {
        background: true,
        backgroundImage: true,
        backgroundSize: options?.backgroundSize || 'cover',
        backgroundPosition: options?.backgroundPosition || 'center',
        backgroundImagePath: url,
      },
    };
    if (options?.duration) config[`${slotName}Duration`] = options.duration;
  }
};
